<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar" v-bind:class="{ branded: embed.enabled }">
            <div class="left">
                <a v-on:click="$router.go(-1)">
                    <svg class="icon icon-arrow-back" aria-hidden="true"></svg>
                </a>
            </div>
            <div class="center">
                <img src="/logo_v2.png" class="logo">
            </div>
        </ons-toolbar>

        <div class="content">
            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>
            <div class="content-inner">
                <template v-if="has_address">
                    <div class="main-header">Address</div>
                    <v-ons-list class="section-h main-text">
                        <v-ons-list-item>
                            <div class="center">Address line 1 & 2</div>
                            <div class="right">{{ address.address }}</div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">City</div>
                            <div class="right">{{ address.city }}</div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">Postcode</div>
                            <div class="right">{{ address.postcode }}</div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">Courier notes</div>
                            <div class="right">
                                <span v-if="helpers.stringEmpty(address.notes)" class="empty-text">
                                    No notes provided
                                </span>
                                <span v-else>{{ address.notes }}</span>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">Last used</div>
                            <div class="right">
                                {{ filters.capitalise(filters.dateRelative(address.last_used_at, 'Never')) }}
                            </div>
                        </v-ons-list-item>
                        <section class="section-vh">
                            <gtc-button v-on:click="deleteAddress" class="btn-action" data-test-id="btn-delete">
                                Delete
                            </gtc-button>
                        </section>
                    </v-ons-list>
                </template>
            </div>
        </div>

    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {
        data () {
            return {
                app: this.$root.$data.app,
                deleting: false,
                address: null,
            }
        },

        mounted(){

            this.app.http.get('user/address/' + this.$route.params.address_id)
                .then(response => {
                    this.address = response.data.address
                })
                .catch(error => {
                    this.$ons.notification.alert(
                        this.app.getResponseErrorMessage(error),
                        { title: 'Unable to load address' }
                    )
                    this.$router.go(-1)
                })
        },

        methods: {

            ...mapMutations([
                'logout',
            ]),

            deleteAddress(){
                this.$ons.notification.confirm(
                        'Are you sure you want to delete this address?',
                        { title: 'Confirm' }
                    )
                    .then((result) => {
                        if (result != 1)
                            return Promise.reject()

                        this.deleting = true
                        return this.app.http.delete('user/address/' + this.$route.params.address_id)
                    })
                    .then(response => {
                        this.deleting = false
                        this.$router.go(-1)
                    })
                    .catch(error => {
                        this.deleting = false
                    })
            },
        },

        computed: {
            ...mapGetters([
                'embed',
            ]),

            has_address: function(){
                return this.address != null
            },

            show_loading: function(){
                return this.has_address == false || this.deleting
            },

        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/user/address.vue